import { render, staticRenderFns } from "./MaterialAdd.vue?vue&type=template&id=a78ea406&scoped=true"
import script from "./MaterialAdd.vue?vue&type=script&lang=js"
export * from "./MaterialAdd.vue?vue&type=script&lang=js"
import style0 from "./MaterialAdd.vue?vue&type=style&index=0&id=a78ea406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78ea406",
  null
  
)

export default component.exports